import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { Grid, Tooltip, Typography } from "@mui/material";

import { useAxios } from "../../hooks";
import pages from "../../constants/pages";
import { colors } from "../css components/Style";

export default function IntermediatePage() {
  const navigate = useNavigate();

  const [agencies, setAgencies] = useState([]);
  const [selected, setSelected] = useState("");

  const authToken = sessionStorage.getItem("parentToken");
  const axios = useAxios({ customAuthToken: authToken });

  async function handleIntermediatePage(agency) {
    await axios({
      url: "/admin/agencies/sessions",
      disableRedirect: true,
      method: "POST",
      data: {
        business_entity_id: agency.business_entity_id,
      },
    }).then((response) => {
      if (response.status) {
        let data = response.data;
        sessionStorage.setItem("authToken", response.data.token);
        sessionStorage.setItem("role", data.user[0]?.role_name);
        sessionStorage.setItem("userID", parseInt(data.user[0]?.user_id));
        sessionStorage.setItem(
          "businessEntityId",
          data.user[0]?.business_entity_id
        );
      }
    });
    navigate(pages.welcomePage.route, {
      state: {
        is_agency_verified: agency.agency_verification_status,
        agencyName: agency.agency_name,
        agencyLogo: agency.logo,
      },
    });
  }

  useEffect(() => {
    axios({
      url: "/getAllAgency?platform_id=1&type=user_agencies",
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setAgencies(response.data.parsedAgency);
      }
    });
  }, [axios]);

  return (
    <Fragment>
      <Grid
        sx={{
          width: "812px",
          marginX: "auto",
          mt: "50px",
          mb: "20px",
        }}
      >
        <Typography
          sx={{
            background: colors.publicisBlue,
            py: 1.5,
            color: "#fff",
            borderRadius: 2,
            textAlign: "center",
            width: "100%",
            fontSize: "18px",
          }}
        >
          Please Select an Agency to Proceed
        </Typography>
      </Grid>

      <div className="category-intermediate-container">
        {agencies.map((category, index) => (
          <Tooltip title={category.agency_name}>
            <div
              onClick={() => {
                sessionStorage.setItem(
                  "businessEntityId",
                  category.business_entity_id
                );
                setSelected(category?.agency_id);
                handleIntermediatePage(category);
              }}
              key={index}
              className="intermediate-page-card"
            >
              <img
                style={{ marginTop: "25px", height: "55px" }}
                src={category.logo}
                alt={category.agency_name}
                className="logo-img"
              />
              <div className="agency-name">{category.agency_name}</div>
            </div>
          </Tooltip>
        ))}
      </div>
    </Fragment>
  );
}
